import { createContext, useContext } from 'react';
import { UserDataType } from './UserData';
import { AuthFlowStart, AuthPurpose, IdentitySettings } from '../authIdentityApi';

export type AuthStatus = 'loading' | 'anonymous' | 'authenticated' | 'error';

export type AuthProfile = Partial<UserDataType> & {
  email?: string | null;
  display_name?: string | null;
  auth_provider?: 'email' | 'google' | 'telegram' | string | null;
};

export type AuthContextType = {
  authStatus: AuthStatus;
  authUser: AuthProfile | null;
  authError: string | null;
  isProfileSaving: boolean;
  requestEmailMagicLink: (email: string, purpose?: AuthPurpose) => Promise<void>;
  completeMagicLink: (token: string) => Promise<void>;
  startGoogleLogin: (purpose?: AuthPurpose) => void;
  loginWithTelegramWidget: (telegramPayload: Record<string, unknown>, purpose?: AuthPurpose) => Promise<void>;
  loginWithTelegramMiniApp: (initData: string, purpose?: AuthPurpose) => Promise<void>;
  saveProfile: (profile: AuthProfile) => Promise<void>;
  logout: () => Promise<void>;
  refreshAuthSession: () => Promise<void>;
  identityActions?: {
    list: () => Promise<IdentitySettings>;
    start: (provider: string, purpose: AuthPurpose, email?: string) => Promise<AuthFlowStart>;
    disconnect: (identityId: number) => Promise<void>;
    completeTelegram: (flowToken: string, evidence: Record<string, unknown>) => Promise<void>;
  };
};

const AuthContext = createContext<AuthContextType | null>(null);

export const useAuthData = () => useContext(AuthContext);

export default AuthContext;
